import { match as matchSearchRoute } from "@faire/web-api/routes/search/match";

export const isSearchPageRoute = (pathname: string, search: string) => {
  if (!pathname.endsWith("/")) {
    pathname += "/";
  }
  return matchSearchRoute(`${pathname}${search}`);
};
